import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import authSliceReducer from "../features/auth/authSlice";
import videosReducer from "../features/videos/videosSlice";
import assignmentsReducer from "../features/assignments/assignmentsSlice";
import quizzesReducer from "../features/quizzes/quizzesSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSliceReducer,
    videos: videosReducer,
    assignments: assignmentsReducer,
    quizzes: quizzesReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: getDefaultMiddlewares => getDefaultMiddlewares().concat(apiSlice.middleware),
});
